import React, {useState} from "react";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import CardTable from "../../components/table/CardTable";
import columns from "./FastActingPartsTableConfig";
import AddButton from "../../components/button/AddButton";
import CardForm from "../../components/form/CardForm";
import fields from "./FastActingPartFormConfig";
import Title from "../line/details/Title";
import {hasFastActingPartFullAccess} from "../../helpers/jwt";
import { useTranslation } from 'react-i18next';

const FastActingPartsTablePage = (props) => {

    const { t } = useTranslation();

    const [loader, setLoader] = useState(false);
    const [creationMode, setCreationMode] = useState(false);
    const [reload, setReload] = useState(false);
    const [selectedPart, setSelectedPart] = useState();

    function selectPart(part) {
        setSelectedPart(part)
        setCreationMode(false)
    }

    function onAdd(part) {

    }

    function onMinus(part) {

    }

    function onRemove(part) {

    }

    function unselect() {
        setSelectedPart(undefined)
    }

    function postCreated() {
        setCreationMode(true)
        setSelectedPart(undefined)
    }

    return (
        <>
            <Loader loader={loader}/>
            <CustomContainer
                title={t("menu.fast_acting_parts")}

                subtitle={
                    <>
                        {hasFastActingPartFullAccess() &&
                            <AddButton
                                show={!creationMode}
                                onClick={postCreated}
                            />
                        }
                    </>
                }>


                <CardTable
                    tittle={t("menu.parts_list")}
                    source={"fastActingPart"}
                    columns={columns(selectPart, onAdd, onMinus, onRemove, t)}
                    width={creationMode || !!selectedPart ? 8 : 12}
                    setLoader={setLoader}
                    striped={false}
                    reload={reload}
                    onReload={unselect}
                    shadow={true}
                />
                {creationMode &&
                    <CardForm
                        title={t("common.add")}
                        api={"fastActingPart"}
                        setLoader={setLoader}
                        fields={fields}
                        width={4}
                        postSaved={() => {
                            setReload(!reload)
                            setCreationMode(false)
                        }}
                        defaultEditMode={true}
                        postCancel={() => {
                            setCreationMode(false)
                        }}

                    />
                }
                {selectedPart &&
                    <CardForm
                        title={<Title
                            name={t("common.details")}
                            label={"ID " + selectedPart?.id}
                        />}
                        setLoader={setLoader}
                        createFormDataFrom={selectedPart}
                        readOnly={true}
                        fields={fields}
                        width={4}
                    />
                }
            </CustomContainer>
        </>
    );
};

export default FastActingPartsTablePage;
